export const reformatName = function(pName) {
  return pName.toString().replace(/ /g, "_");
};
